import clsx from 'clsx';
import { HTMLProps, forwardRef } from 'react';

import CheckIcon from '~/shared/assets/icons/check.svg';

const Switch = forwardRef<
  HTMLInputElement,
  HTMLProps<HTMLInputElement> & {
    className?: string;
  }
>(({ className, checked, disabled, ...inputProps }, ref) => {
  return (
    <div
      className={clsx(
        className,
        'rounded-[100px] w-[43px] h-[25px]   flex relative z-0 transition-all duration-300',
        checked ? 'bg-primary-500' : disabled ? 'bg-[#C8CACC]/40' : 'bg-[#C8CACC]'
      )}
    >
      <div
        className={clsx(
          'absolute right-[4.17px] top-[4px] bg-white rounded-full w-[17.5px] h-[17.5px] flex justify-center items-center z-[1]',
          checked ? 'left-[calc(100%_-_21.67px)]' : 'left-[4.33px] shadow-switch'
        )}
      >
        <CheckIcon
          className={clsx(
            ' stroke-primary-500 transition-opacity duration-200',
            checked ? 'opacity-100' : 'opacity-0'
          )}
        />
      </div>

      <input
        ref={ref}
        type="checkbox"
        className={
          'absolute z-10 opacity-0 peer w-full h-full cursor-pointer disabled:cursor-default'
        }
        checked={checked}
        disabled={disabled}
        {...inputProps}
      />
    </div>
  );
});

Switch.displayName = 'Switch';

export default Switch;
